import { landlordUserApi } from '@afinius/api-client/landlord-user/api';
import { LandlordUser } from '@afinius/api-client/landlord-user/types';
import { message } from 'ant-design-vue';
import { defineStore } from 'pinia';
import { type Ref, ref } from 'vue';

interface State {
  user: Ref<LandlordUser | undefined>;
  fetchUser: () => Promise<void>;
  reset: () => void;
}

export const useLandlordUserStore = defineStore('landlord-user', (): State => {
  const user = ref<LandlordUser>();

  const fetchUser = async () => {
    user.value = await landlordUserApi.user().catch((error) => {
      if (error.response && error.response.status !== 451 && error.response.data) {
        message.error(error.response.data.message);
      }

      return undefined;
    });
  };

  const reset = () => {
    user.value = undefined;
  };

  return {
    user,
    fetchUser,
    reset,
  };
});
